export default __webpack_public_path__ + "static/media/bianca fluted panel.6d857f7e.png";